

// MUI helper functions
import pxToRem from "../functions/pxToRem";

// MUI base styles
import colors from "../base/colors";
import boxShadows from "../base/boxShadows";
import borders from "../base/borders";

const { white } = colors;
const { lg } = boxShadows;
const { borderRadius } = borders;

const popover = {
  styleOverrides: {
    // Solid white surface. Was `transparent`, which made every Select/Menu
    // dropdown render see-through — looked like "the selector isn't popping".
    paper: {
      backgroundColor: white.main,
      boxShadow: lg,
      padding: pxToRem(8),
      borderRadius: borderRadius.lg,
    },
  },
};

export default popover;
